import { MapPinOutlineIcon, PlayCircleIcon, ThreeDTourIcon } from '../../../ui/icons';
import * as styles from './photoGallery.styles';

type MobileGalleryButtonsProps = {
  hasVideos?: boolean;
  has3dTour?: boolean;
  hasStreetView?: boolean;
  onVideosClick?: () => void;
  on3dTourClick?: () => void;
  onStreetViewClick?: () => void;
};

export const MobileGalleryButtons = ({
  hasVideos,
  has3dTour,
  hasStreetView,
  onVideosClick,
  on3dTourClick,
  onStreetViewClick,
}: MobileGalleryButtonsProps) => {
  if (!hasVideos && !has3dTour && !hasStreetView) return null;

  return (
    <div className={styles.mobileOverlayButtons}>
      {has3dTour && on3dTourClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            on3dTourClick();
          }}
          aria-label="View 3D tours"
        >
          <ThreeDTourIcon />
          3D tours
        </button>
      )}
      {hasVideos && onVideosClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            onVideosClick();
          }}
          aria-label="View videos"
        >
          <PlayCircleIcon />
          Videos
        </button>
      )}
      {hasStreetView && onStreetViewClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            onStreetViewClick();
          }}
          aria-label="View street view"
        >
          <MapPinOutlineIcon />
          Street view
        </button>
      )}
    </div>
  );
};
